import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import ProfileSidebar from '../components/profile/ProfileSidebar';
import { getProfileSubscriptionPlan } from '../constants/subscriptionPlans';
import { getUserSession } from '../services/authService';
import '../styles/profile.css';

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <path d="M5 12l4 4 10-10" />
  </svg>
);

const ProfileSubscriptionsPage = () => {
  const sessionUser = getUserSession();
  const plan = getProfileSubscriptionPlan(sessionUser?.plan || 'basico');

  if (!sessionUser) {
    return <Redirect to="/iniciar-sesion" />;
  }

  return (
    <div className="profile-root">
      <div className="profile-layout">
        <ProfileSidebar activeId="subscriptions" />

        <section className="profile-main">
          <div className="profile-subscription-card">
            <div className="profile-subscription-header">
              <div>
                <p className="profile-subscription-tier">{plan.tier}</p>
                <h1 className="profile-subscription-price">{plan.priceLabel}</h1>
              </div>

              {plan.isCurrent ? (
                <span className="profile-subscription-badge">
                  <span className="profile-subscription-badge-icon" aria-hidden="true">
                    <CheckIcon />
                  </span>
                  Plan actual
                </span>
              ) : null}
            </div>

            <ul className="profile-subscription-features">
              {plan.features.map((feature) => (
                <li key={feature.title} className="profile-subscription-feature">
                  <span className="profile-subscription-feature-icon" aria-hidden="true">
                    <CheckIcon />
                  </span>
                  <div>
                    <p className="profile-subscription-feature-title">{feature.title}</p>
                    {feature.items.map((item) => (
                      <p key={item} className="profile-subscription-feature-text">
                        {item}
                      </p>
                    ))}
                  </div>
                </li>
              ))}
            </ul>

            {plan.id === 'basico' ? (
              <div className="profile-subscription-upgrade">
                <Link to="/subscriptions" className="profile-subscription-upgrade-link">
                  Ver plan Premium
                </Link>
              </div>
            ) : null}
          </div>
        </section>
      </div>
    </div>
  );
};

export default ProfileSubscriptionsPage;
